import {
  formatDailyFluids as formatDailyFluidsByPreference,
  formatFluidsMlPerHour as formatFluidsMlPerHourByPreference,
  formatHeightFromInches as formatHeightFromInchesByPreference,
  formatTargetWeightRangeFromPounds,
  formatTemperatureFromFahrenheit as formatTemperatureFromFahrenheitByPreference,
  formatWeightFromPounds
} from "../../lib/unitPreferences";
import type { AthleteProfile, PreferredUnits } from "./types/athleteProfile";

export function formatWeightFromLb(weightLb: number, units: PreferredUnits): string {
  return formatWeightFromPounds(weightLb, units);
}

export function formatTargetWeightRange(range: AthleteProfile["personal"]["targetWeightLb"], units: PreferredUnits): string {
  return formatTargetWeightRangeFromPounds(range, units);
}

export function formatHeightFromInches(heightInches: number, units: PreferredUnits): string {
  return formatHeightFromInchesByPreference(heightInches, units);
}

export function formatTemperatureFromFahrenheit(temperatureF: number, units: PreferredUnits): string {
  return formatTemperatureFromFahrenheitByPreference(temperatureF, units);
}

export function formatFluidsMlPerHour(fluidsMlPerHour: number, units: PreferredUnits): string {
  return formatFluidsMlPerHourByPreference(fluidsMlPerHour, units);
}

export function formatDailyFluids(fluidsMl: number, units: PreferredUnits): string {
  return formatDailyFluidsByPreference(fluidsMl, units);
}

export function formatCountdownToDate(targetDate: string | null): string {
  if (!targetDate) {
    return "Date not set";
  }

  const eventDate = new Date(targetDate);
  if (Number.isNaN(eventDate.getTime())) {
    return "Date not set";
  }

  const now = new Date();
  const millis = eventDate.getTime() - now.getTime();
  const dayMs = 24 * 60 * 60 * 1000;
  const days = Math.ceil(millis / dayMs);

  if (days < 0) {
    return "Event date passed";
  }

  if (days === 0) {
    return "Today";
  }

  return `${days} day${days === 1 ? "" : "s"}`;
}

export function formatEventDate(targetDate: string | null): string {
  if (!targetDate) {
    return "Date not set";
  }

  const date = new Date(targetDate);
  if (Number.isNaN(date.getTime())) {
    return "Date not set";
  }

  return date.toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });
}

export function formatColdPlungeTiming(value: AthleteProfile["recovery"]["morningColdPlungeTiming"]): string {
  if (value === "immediately-after-waking") {
    return "Immediately after waking";
  }
  if (value === "pre-training") {
    return "Pre-training";
  }
  if (value === "post-training") {
    return "Post-training";
  }
  return "Evening";
}
